import { lazy, LazyExoticComponent } from 'react';

export const PageComponents: Record<string, LazyExoticComponent<any>> = {
  profile: lazy(() => import('../views/profile/Profile').then((m) => ({ default: m.Profile }))),
  team: lazy(() => import('../views/team/Team').then((m) => ({ default: m.Team }))),
  company: lazy(() =>
    import('../views/company/CompanyView').then((m) => ({ default: m.CompanyView }))
  ),
  groups: lazy(() => import('../views/team/Group').then((m) => ({ default: m.Group }))),
  practicals: lazy(() =>
    import('../views/practicals/Practicals').then((m) => ({ default: m.Practicals }))
  ),
  feedback: lazy(() => import('./FeedbackRoutes')),
  settings: lazy(() => import('../views/settings/Settings').then((m) => ({ default: m.Settings }))),
  signup: lazy(() =>
    import('../views/signup/OrgSignupView').then((m) => ({ default: m.OrgSignupView }))
  ),
  onboarding: lazy(() =>
    import('../views/onboarding/Onboarding').then((m) => ({ default: m.Onboarding }))
  ),
  'my-klayo': lazy(() => import('./MyKlayoRoutes')),
  manage: lazy(() => import('./ManageRoutes')),
  'pricing-and-checkout': lazy(() =>
    import('../views/pricing/PricingPage').then((m) => ({ default: m.PricingPage }))
  ),
  'solution-finder': lazy(() =>
    import('../views/solution-finder/SolutionFinderPage').then((m) => ({
      default: m.SolutionFinderPage,
    }))
  ),
  'job-benchmarking': lazy(() =>
    import('../views/job-benchmarking/JobBenchmarkingPage').then((m) => ({
      default: m.JobBenchmarkingPage,
    }))
  ),
  'job-builder': lazy(() =>
    import('../views/job-builder/JobBuilderPage').then((m) => ({ default: m.JobBuilderPage }))
  ),
  try: lazy(() => import('../views/try/TryPage').then((m) => ({ default: m.TryPage }))),
  'my-account': lazy(() =>
    import('../views/my-account/MyAccountView').then((m) => ({ default: m.MyAccountView }))
  ),
};
